export function downloadCSV(content: string, filename: string) {
  const blob = new Blob([content], { type: 'text/csv' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = filename
  // Append the anchor to the body (required for Firefox)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
